import {createActions} from 'redux-actions';

const {confirm} = createActions({
    CONFIRM: {
        SHOW: undefined,
        HIDE: undefined,
    }
});

export default confirm;